var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipskip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06513 1.15956C2.69711 0.870877 3.40023 0.759688 4.09437 0.838663C4.78851 0.917639 5.44575 1.1836 5.99119 1.60625L15.0513 8.83913L15.3 9.09684V2.53398C15.3 2.07833 15.4872 1.64135 15.8204 1.31915C16.1535 0.996962 16.6054 0.815956 17.0765 0.815956C17.5477 0.815956 17.9995 0.996962 18.3327 1.31915C18.6659 1.64135 18.853 2.07833 18.853 2.53398V19.7142C18.853 20.1699 18.6659 20.6069 18.3327 20.9291C17.9995 21.2513 17.5477 21.4323 17.0765 21.4323C16.6054 21.4323 16.1535 21.2513 15.8204 20.9291C15.4872 20.6069 15.3 20.1699 15.3 19.7142V13.1514L15.0513 13.4091L5.99119 20.642C5.33812 21.1542 4.52258 21.4332 3.68175 21.4323C3.12387 21.4291 2.57298 21.312 2.06513 21.0886C1.51589 20.8545 1.04794 20.4724 0.717171 19.9881C0.386402 19.5037 0.2068 18.9374 0.199812 18.357V3.89122C0.2068 3.31078 0.386402 2.74455 0.717171 2.26016C1.04794 1.77577 1.51589 1.39369 2.06513 1.15956ZM3.75281 17.9962L12.3155 11.1241L3.75281 4.40663V17.9962Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipskip);
export default __webpack_public_path__ + "static/media/skipskip.04dd038a40b0d96dc0bf8f133dd9105a.svg";
export { ForwardRef as ReactComponent };